import { loaderBlackGif, loaderGif } from "../utils/constants";

function LoadingScreen({ size = 60, loaderType = "default", url }: { size?: number; loaderType?: string; url?: string }) {
	return (
		<div className="flex items-center justify-center h-full w-full">
			<img src={url ? url: (loaderType === "black" ? loaderBlackGif : loaderGif)} alt="Swan logo" className={`w-[${size}px] h-[${size}px]`} width={size} />
		</div>
	);
}

export default LoadingScreen;
